<template>
  <div id="app">
    <!-- SIDEBAR AND MAIN CONTENT -->
    <div class="columns is-mobile is-gapless is-marginless">
      <!-- SIDEBAR -->
      <upd-sidebar></upd-sidebar>

      <!-- MAIN CONTENT -->
      <div class="column">
        <!-- NAVBAR -->
        <upd-navbar></upd-navbar>
        <div id="main-content" class="main-content custom-scrollbar">
          <breadcrumb></breadcrumb>
          <transition name="fade" mode="out-in">
            <router-view></router-view>
          </transition>
          <!-- FOOTER -->
        </div>
        <upd-footer></upd-footer>
      </div>
    </div>
    <!-- Floating button -->
    <fab :actions="fabActions" @alertMe="alert" bg-color="#1b98cf"></fab>
  </div>
</template>

<script>
import fab from 'vue-fab';
import UpdSidebar from './components/partials/Sidebar.vue';
import UpdNavbar from './components/partials/Navbar.vue';
import UpdFooter from './components/partials/Footer.vue';
import Breadcrumb from './components/partials/Breadcrumb.vue';

export default {
  name: 'app',
  components: {
    fab, UpdSidebar, UpdNavbar, UpdFooter, Breadcrumb,
  },
  data() {
    return {
      swipeOffset: 0,
      fabActions: [
        {
          name: 'alertMe',
          icon: 'add_alert',
        },
      ],
    };
  },
  mounted() {
  },
  methods: {
    alert() {
    },
  },
};
</script>

<style lang="scss">
  @import "./assets/scss/app.scss";
</style>
